var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinityQuestionmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 233.667,
    height: 410.399,
    viewBox: "0 0 233.667 410.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.106,
    y1: 0.414,
    x2: 0.93,
    y2: 0.563,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#e7d62b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dfc825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#d0b01a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#bc8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc8e0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.137,
    y1: 0.41,
    x2: 0.981,
    y2: 0.619,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -18.082,
    y1: 56.727,
    x2: -17.256,
    y2: 56.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -46.261,
    y1: 189.232,
    x2: -45.401,
    y2: 189.445,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4.072,
    y1: -65.561,
    x2: -3.245,
    y2: -65.413,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -9.405,
    y1: -226.981,
    x2: -8.572,
    y2: -226.776,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1.525,
    y1: -2.822,
    x2: 0.904,
    y2: -2.413,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(-14.951 -564.924)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 89.481,
    cy: 8.442,
    rx: 89.481,
    ry: 8.442,
    transform: "translate(35.294 956.819)",
    fill: "#707070",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Infinity_10",
    "data-name": "Infinity 10",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 56.27, 559.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M213.015,107.425q-.223,3.06-.627,6.091a101.33,101.33,0,0,1-2.537,12.621,104.747,104.747,0,0,1-6.842,18.378,108.5,108.5,0,0,1-8.364,14.432,110.717,110.717,0,0,1-39.56,35.338q-4.449,2.352-9.15,4.278a103.942,103.942,0,0,1-77.127.743c-.705-.277-1.41-.561-2.106-.854q-3.557-1.472-6.953-3.2c-.708-.36-1.407-.719-2.1-1.1-.112-.058-.225-.125-.337-.183a109.235,109.235,0,0,1-40.072-37.745c-.306-.489-.612-.979-.918-1.476A112.58,112.58,0,0,1,9.48,141.746c-.244-.535-.481-1.069-.708-1.611a111.009,111.009,0,0,1-5.263-15.307A104.347,104.347,0,0,1,.9,111.732a99.73,99.73,0,0,1-.691-19.81A94.105,94.105,0,0,1,4.226,70.237C9.357,53.585,18.507,40.036,27.773,29.7v-.008A136.289,136.289,0,0,1,40.057,17.644,120.992,120.992,0,0,1,56.935,5.25l.1-.017c.279-.063.56-.126.838-.18a235.407,235.407,0,0,1,89.386-1.476q2.853.5,5.536,1.037c.008,0,.016.009.024.01.641.121,1.282.252,1.907.381.1.024.189.039.287.062q2.365,1.348,4.649,2.79c.264.161.518.329.772.5a119.5,119.5,0,0,1,26.79,23.437V31.8a115.052,115.052,0,0,1,7.252,9.516c1.258,1.843,2.464,3.723,3.6,5.631q1.15,1.9,2.205,3.838A107.592,107.592,0,0,1,209.421,73.1a99.459,99.459,0,0,1,2.573,11.61,98.268,98.268,0,0,1,1.022,22.711Z",
    transform: "translate(0 188.929)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M106.925,10.807a2.525,2.525,0,0,1-.6,1.54c-1.014,1.327-3.33,2.567-6.687,3.665-.017.007-.042.013-.06.021A80.4,80.4,0,0,1,87.8,18.66l-.97.155A223.66,223.66,0,0,1,53.39,20.873c-5.325-.029-10.473-.221-15.326-.541h-.008c-15.982-1.04-28.811-3.483-34.641-6.543-.257-.136-.5-.278-.728-.412A5.31,5.31,0,0,1,.1,10.721a2.188,2.188,0,0,1-.1-.649,2.512,2.512,0,0,1,.072-.536,2.256,2.256,0,0,1,.214-.526A4.57,4.57,0,0,1,1.681,7.493c.167-.121.343-.242.519-.371a.259.259,0,0,0,.062-.037A16.955,16.955,0,0,1,4.592,5.879C12.925,2.284,31.711-.142,53.536.006,71.278.124,87,1.919,96.7,4.585a.027.027,0,0,1,.024.01c1,.273,1.927.557,2.79.845.008,0,.016.009.024.01,3.882,1.308,6.392,2.783,7.146,4.347a2.3,2.3,0,0,1,.244,1.009Z",
    transform: "translate(53.284 188.102)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M42.283,14.159A196.17,196.17,0,0,0,19.1,56.073,35.28,35.28,0,0,1,0,40.539C5.132,23.887,14.281,10.339,23.547,0a30.871,30.871,0,0,0,7.546,8.614A30.906,30.906,0,0,0,42.283,14.16Z",
    transform: "translate(4.222 218.624)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M41.14,41.3A35.638,35.638,0,0,1,34.475,48.9a35.472,35.472,0,0,1-12.669,6.914A196.168,196.168,0,0,0,12.306,34,196.024,196.024,0,0,0,0,13.169,31.054,31.054,0,0,0,11.367,7.985,30.711,30.711,0,0,0,18.944,0,115.263,115.263,0,0,1,26.2,9.516c1.258,1.843,2.464,3.723,3.6,5.631q1.15,1.9,2.205,3.838A107.586,107.586,0,0,1,41.14,41.3Z",
    transform: "translate(168.282 220.73)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 34.923,
    height: 24.945,
    rx: 6.711,
    transform: "translate(89.035 234.165) rotate(0.36)",
    fill: "#2eb3bd",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 8.783,
    height: 77.181,
    transform: "matrix(1, 0.011, -0.011, 1, 102.107, 259.171)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M211.486,1.784A101.32,101.32,0,0,1,208.949,14.4,174,174,0,0,1,181.37,29.488c-.077.036-.155.064-.232.1C141.908,46.54,107.089,44.27,93.326,43.209A206.183,206.183,0,0,1,18.911,22.18c-6.3-3.135-11.767-6.268-16.305-9.084A104.345,104.345,0,0,1,0,0C2.73,1.783,5.88,3.747,9.416,5.8A207.126,207.126,0,0,0,83.156,31.73c6.133.856,11.933,1.353,17.266,1.625q4.636.224,8.78.231a170.206,170.206,0,0,0,23.866-1.429,183.95,183.95,0,0,0,50.814-14.941c4.941-2.249,10.048-4.829,15.249-7.777,4.826-2.733,8.971-5.374,12.355-7.655Z",
    transform: "translate(0.902 300.66)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M57.225,56.7q-3.557-1.472-6.953-3.2c-.708-.36-1.407-.719-2.1-1.1a99.15,99.15,0,0,0,1.678-14.227,10.337,10.337,0,0,0-1.616-6.662,10.122,10.122,0,0,0-3.9-3.086,9,9,0,0,0-2.044-.557,191.089,191.089,0,0,1-34.525-13.4c-.306-.489-.612-.979-.918-1.476A112.58,112.58,0,0,1,0,0C.24.142.5.294.743.437A213.5,213.5,0,0,0,50.089,21.216a11.274,11.274,0,0,1,2.281.625,12.315,12.315,0,0,1,7.9,12.407A100.836,100.836,0,0,1,57.225,56.7Z",
    transform: "translate(9.48 330.675)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M59.56,0A108.5,108.5,0,0,1,51.2,14.432a191.488,191.488,0,0,1-33.1,12.08,8.781,8.781,0,0,0-2.056.534,10.2,10.2,0,0,0-3.955,3.013,10.38,10.38,0,0,0-1.71,6.646,100.245,100.245,0,0,0,1.257,13.065q-4.448,2.352-9.15,4.277A100.5,100.5,0,0,1,.021,32.606a12.32,12.32,0,0,1,8.09-12.284,11.293,11.293,0,0,1,2.293-.583A213.829,213.829,0,0,0,59.558,0Z",
    transform: "translate(143.448 333.447)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M93.977,4.4c-10.883-.426-26.6,2.6-38.39,9.435-2.96,1.719-8.848,5.517-17.523,6.494h-.008c-4.061.454-7.02.1-11.448-.451-7.237-.911-17.821-3.157-23.194-6.092-.257-.136-.5-.278-.728-.412A5.669,5.669,0,0,1,.1,10.721a2.189,2.189,0,0,1-.1-.649,2.516,2.516,0,0,1,.072-.536,2.644,2.644,0,0,1,.214-.526A5.044,5.044,0,0,1,1.681,7.493c.167-.121.343-.242.519-.371a.259.259,0,0,0,.062-.037c.475-.333.975-.679,1.492-1.025.279-.063.56-.126.838-.181C12.924,2.284,31.71-.142,53.536.006,71.278.124,87,1.919,96.7,4.585c-.869-.088-1.773-.154-2.722-.181Z",
    transform: "translate(53.283 188.102)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M93.484,99.57q-.223,3.06-.627,6.091a101.312,101.312,0,0,1-2.537,12.621,104.744,104.744,0,0,1-6.842,18.378,108.515,108.515,0,0,1-8.364,14.432,110.718,110.718,0,0,1-39.56,35.338q-4.449,2.352-9.15,4.278A103.526,103.526,0,0,1,0,197.689,149.309,149.309,0,0,0,20.679,185.3c12.427-8.866,27.739-19.8,37.392-40.256a82.292,82.292,0,0,0,4.437-11.583,86.359,86.359,0,0,0,2.744-12.374A124.193,124.193,0,0,0,66.4,107.118C67.407,79.5,56.325,57.092,56.325,57.092c-3.888-8.317-10.887-22.851-26.542-34.91A82.255,82.255,0,0,0,10.829,11.276C12.58,11.092,26.7,9.6,29.094,8.793A33.447,33.447,0,0,0,33.325,7.35c.018-.007.042-.013.06-.021a35.7,35.7,0,0,0,6.686-3.665,5.856,5.856,0,0,0,.361-2.55A3.334,3.334,0,0,0,40.13,0,119.813,119.813,0,0,1,67.693,23.936v.008a115.085,115.085,0,0,1,7.252,9.516c1.258,1.843,2.464,3.723,3.6,5.631q1.15,1.9,2.205,3.838a107.59,107.59,0,0,1,9.138,22.318,99.469,99.469,0,0,1,2.573,11.61,98.273,98.273,0,0,1,1.022,22.711Z",
    transform: "translate(119.531 196.783)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M57.317,176.329a109.236,109.236,0,0,1-40.072-37.745c-.306-.489-.612-.979-.918-1.476A112.566,112.566,0,0,1,9.48,124.1c-.245-.535-.481-1.068-.709-1.611a111.026,111.026,0,0,1-5.263-15.307A104.349,104.349,0,0,1,.9,94.088a99.733,99.733,0,0,1-.691-19.81A94.107,94.107,0,0,1,4.226,52.593c5.132-16.652,14.281-30.2,23.547-40.539v-.008A136.285,136.285,0,0,1,40.057,0c-2.1,3.133-4.389,6.684-6.785,10.612C26.029,22.482,17.859,35.86,12.939,50.635c-.78,2.352-8.475,26.263-4.2,52.679,6.01,37.223,32.9,61.61,48.584,73.016Z",
    transform: "translate(0 206.574)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M31.417,4.977a6.745,6.745,0,0,1-3.641,3.754.161.161,0,0,0-.052.03,49.851,49.851,0,0,1-7.889,2.885A60.06,60.06,0,0,1,.067,14.266H.05L0,14.261a116.014,116.014,0,0,0,11.722-3.207c8.38-2.767,12.6-4.2,13.86-7.145a6.633,6.633,0,0,0,.41-3.564C25.975.236,25.96.118,25.935,0c.1.024.189.039.287.062q2.365,1.348,4.649,2.79c.264.161.518.329.773.5a5.1,5.1,0,0,1-.227,1.626Z",
    transform: "translate(128.792 193.932)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M113.791,182.875a11.231,11.231,0,0,1-4.985,2.964,139.015,139.015,0,0,1-55.343,9.692q-1.71-.05-3.366-.146a138.482,138.482,0,0,1-34.542-6.418c-1.621-.526-3.159-1.047-4.6-1.569a11.167,11.167,0,0,1-5-2.766A10.952,10.952,0,0,1,2.6,176.867L0,18.164A11.462,11.462,0,0,1,3.109,10.3a11.1,11.1,0,0,1,3.02-2.206A11.354,11.354,0,0,1,9.2,7.079H9.2A185.41,185.41,0,0,1,105.161,5.6c.1.016.214.041.337.067a11.209,11.209,0,0,1,3.709,1.5,10.228,10.228,0,0,1,1.735,1.36,11.516,11.516,0,0,1,3.369,7.766L116.9,175a11.587,11.587,0,0,1-3.108,7.877Z",
    transform: "translate(47.97 0.002)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M98.759,155.988c-2.543.916-4.871,1.863-6.965,2.786A9.074,9.074,0,0,0,87.6,161.6a11.487,11.487,0,0,0-2.338,4.515,12.806,12.806,0,0,0-.432,3.287L84.8,175.04a98.324,98.324,0,0,1-56.12,4.349,102.191,102.191,0,0,1-11.71-3.262l-.55-6.635a12.81,12.81,0,0,0-.689-3.244,11.475,11.475,0,0,0-2.678-4.322,8.952,8.952,0,0,0-4.4-2.488c-1.885-.671-3.955-1.339-6.193-1.977L0,7.08H.008A185.3,185.3,0,0,1,88.782,3.95c2.546.527,4.94,1.085,7.184,1.649.1.016.214.041.337.067l2.456,150.322Z",
    transform: "translate(57.164)",
    fill: "#353f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M63.694,175.707a11.232,11.232,0,0,1-4.985,2.964,139.015,139.015,0,0,1-55.343,9.692q-1.71-.05-3.366-.146c25.462-4.34,44.033-9.073,50.979-12.636a17.252,17.252,0,0,0,7.936-7.2,16.776,16.776,0,0,0,1.49-10.271Q59.724,94.515,59.3,30.93,59.188,15.464,59.109,0a10.228,10.228,0,0,1,1.735,1.36,11.517,11.517,0,0,1,3.369,7.766L66.8,167.83a11.587,11.587,0,0,1-3.108,7.877Z",
    transform: "translate(98.067 7.17)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M70.082,152.037c-2.543.916-4.871,1.863-6.965,2.786a9.075,9.075,0,0,0-4.191,2.821,11.488,11.488,0,0,0-2.338,4.515,12.806,12.806,0,0,0-.432,3.287l-.036,5.642a99.656,99.656,0,0,1-39.343,6.489A99.109,99.109,0,0,1,0,175.437,211.928,211.928,0,0,0,39.2,164.27a36.546,36.546,0,0,0,5.738-2.542C63.209,150.8,61.325,120.016,60.446,70.961,60.153,54.5,59.872,30.2,60.1,0c2.546.527,4.94,1.085,7.184,1.649.1.016.214.041.337.067l2.456,150.322Z",
    transform: "translate(85.841 3.951)",
    fill: "#15192f",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M15.555,180.878c-1.621-.526-3.159-1.047-4.6-1.569a11.167,11.167,0,0,1-5-2.766A10.952,10.952,0,0,1,2.6,168.778L0,10.075A11.462,11.462,0,0,1,3.109,2.206,11.1,11.1,0,0,1,6.129,0c-.617,2.515-1.25,5.487-1.785,8.833a110.2,110.2,0,0,0-1.37,18.8c.27,31.085.4,46.637.672,67.117.288,21.807,3.069,43.6,2.273,65.39a24.2,24.2,0,0,0,.912,7.846A27.183,27.183,0,0,0,15.555,180.878Z",
    transform: "translate(47.97 8.091)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M22.425,3.141C16.741-1.837,9.526.549,9.024.725a13.9,13.9,0,0,0-7.14,5.822A13.573,13.573,0,0,0,.027,12.509,4.122,4.122,0,0,0,0,12.965v1.444A4.111,4.111,0,0,0,4.111,18.52H5.556a4.111,4.111,0,0,0,4.111-4.111V13.182a4.334,4.334,0,0,1,1.554-3.231,4.054,4.054,0,0,1,5.383.329,3.887,3.887,0,0,1,.637,3.127L10.994,30.895a4.17,4.17,0,0,0,2.523,5.329l1.354.484A4.17,4.17,0,0,0,20.2,34.184l5.013-14.031h0L26.445,16.7c.054-.186.127-.458.2-.788A13.614,13.614,0,0,0,22.425,3.143Z",
    transform: "translate(91.218 64.926)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 10.686,
    height: 10.686,
    rx: 5.343,
    transform: "translate(100.226 103.286)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M10.543.751a7.6,7.6,0,0,0-7.269.456A7.436,7.436,0,0,0,.309,5.142a7.263,7.263,0,0,0-.2,3.334,2.4,2.4,0,0,0,.044.24l.185.75a2.2,2.2,0,0,0,2.66,1.611l.75-.185a2.2,2.2,0,0,0,1.61-2.66L5.2,7.594a2.314,2.314,0,0,1,.395-1.876A2.168,2.168,0,0,1,8.43,5.2a2.079,2.079,0,0,1,.73,1.543L8.148,16.625a2.229,2.229,0,0,0,1.991,2.445l.765.078a2.229,2.229,0,0,0,2.445-1.991l.812-7.927h0l.2-1.95c0-.1.008-.254,0-.435A7.281,7.281,0,0,0,10.543.752Z",
    transform: "translate(77.73 87.047)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 5.715,
    height: 5.715,
    rx: 2.755,
    transform: "translate(85.801 107.801) rotate(-13.809)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M15.492,4.076C13.156.035,8.462,0,8.133,0A8.6,8.6,0,0,0,2.8,1.987,8.37,8.37,0,0,0,.528,5.105a2.494,2.494,0,0,0-.106.261l-.287.845A2.539,2.539,0,0,0,1.724,9.432l.845.287A2.539,2.539,0,0,0,5.79,8.131l.244-.718A2.678,2.678,0,0,1,7.585,5.833a2.505,2.505,0,0,1,3.083,1.262,2.4,2.4,0,0,1-.249,1.956L3.292,18.037a2.575,2.575,0,0,0,.417,3.618l.7.552a2.575,2.575,0,0,0,3.618-.417l5.72-7.211h0L15.15,12.8c.069-.1.165-.243.272-.422A8.411,8.411,0,0,0,15.492,4.076Z",
    transform: "translate(120.677 83.615)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 6.602,
    height: 6.602,
    rx: 3.301,
    transform: "matrix(0.947, 0.322, -0.322, 0.947, 121.322, 105.626)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M84.086,143.795c-2.216.837-4.247,1.7-6.074,2.548a7.935,7.935,0,0,0-3.667,2.588,10.908,10.908,0,0,0-2.078,4.153,12.551,12.551,0,0,0-.41,3.026l-.092,5.2a82.379,82.379,0,0,1-34.209,5.874,80.979,80.979,0,0,1-14.536-2.014,83.979,83.979,0,0,1-10.126-3.035l-.406-6.113a12.362,12.362,0,0,0-.563-2.989,10.536,10.536,0,0,0-2.278-3.988,7.557,7.557,0,0,0-3.788-2.3c-1.629-.623-3.417-1.243-5.352-1.837L0,6.389H.007a153.136,153.136,0,0,1,38.4-6.3A151.257,151.257,0,0,1,77.072,3.738c2.2.492,4.275,1.012,6.216,1.538.086.015.185.038.292.062l.506,138.457Z",
    transform: "translate(64.9 8.413)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M69.975,128.695c-1.859.76-3.564,1.547-5.1,2.313a6.744,6.744,0,0,0-3.083,2.337,10.174,10.174,0,0,0-1.76,3.732,11.994,11.994,0,0,0-.358,2.714l-.1,4.658a65.357,65.357,0,0,1-28.667,5.429,63.356,63.356,0,0,1-12.159-1.735,66.267,66.267,0,0,1-8.463-2.672l-.311-5.477a11.766,11.766,0,0,0-.457-2.677,9.468,9.468,0,0,0-1.888-3.563,6.165,6.165,0,0,0-3.16-2.046c-1.36-.551-2.855-1.1-4.472-1.621L.237,5.938H.243A121.237,121.237,0,0,1,32.424.11,118.212,118.212,0,0,1,64.773,3.192c1.843.431,3.574.887,5.2,1.348.072.012.155.033.244.054l-.239,124.1Z",
    transform: "translate(72.294 16.157)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M.744,113.214Q.373,59.827,0,6.439a127.665,127.665,0,0,1,12.855-3.51A130.6,130.6,0,0,1,54.884.8C49.226,1.928,40.872,3.761,30.807,6.624c-9.205,2.619-11.071,3.6-12.3,4.386C8,17.723,6.908,33.58,6.216,43.206c-1.543,21.464-3.4,44-5.471,70.008Z",
    transform: "translate(60.801 5.917)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M4.359,10.475A5.493,5.493,0,0,1,1.131,8.511,5.517,5.517,0,0,1,.04,4.5,5.344,5.344,0,0,1,2.221.833,5.215,5.215,0,0,1,5.057,0C8.219-.1,10.531,2.241,11.034,2.752a27.542,27.542,0,0,1,1.783,2.11c.641.827.852,1.178,1.216,1.67a9.682,9.682,0,0,0,3.72,3.463,5.766,5.766,0,0,0,4.188.305,5.638,5.638,0,0,0,3.155-2.818,5.231,5.231,0,0,0,.493-3.634,4.983,4.983,0,0,0-1.047-1.971A5.534,5.534,0,0,0,22.475.335a6.976,6.976,0,0,0-6.075.935,12.456,12.456,0,0,0-1.661,1.3c-.069.065-.123.118-.161.155a13.958,13.958,0,0,0-1.761,2.142c-.605.866-.707,1.154-1.085,1.73a8.819,8.819,0,0,1-3.665,3.36,5.956,5.956,0,0,1-3.708.524Z",
    transform: "translate(93.554 241.369)",
    fill: "none",
    stroke: "#139093",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityQuestionmark);
export default __webpack_public_path__ + "static/media/infinity-questionmark.621ca329103d15a296e3b8a3a7ce0a58.svg";
export { ForwardRef as ReactComponent };